export const PANELS = {
  nameAndColor: 'nameAndColor',
  duration: 'duration',
  location: 'location',
  availability: 'availability',
  groupEvent: 'groupEvent',
  hosts: 'hosts',
  assign: 'assign',
  description: 'description',
  limitsAndBuffers: 'limitsAndBuffers',
  freeBusyRules: 'freeBusyRules',
  bookingPageOptions: 'bookingPageOptions',
  inviteeForm: 'inviteeForm',
  payment: 'payment',
  notifications: 'notifications',
  confirmationPage: 'confirmationPage'
}

// these map the panel key to the lock name for sections that show as locked for parent MET
export const panelLockNames = {
  [PANELS.nameAndColor]: 'v3_name_and_color',
  [PANELS.duration]: 'v3_duration',
  [PANELS.availability]: 'v3_availability',
  [PANELS.groupEvent]: 'v3_invitee_limit',
  [PANELS.description]: 'v3_description',
  [PANELS.limitsAndBuffers]: 'v3_limits_and_buffers',
  [PANELS.bookingPageOptions]: 'v3_booking_page',
  [PANELS.inviteeForm]: 'v3_invitee_form',
  [PANELS.payment]: 'v3_payment_method',
  [PANELS.notifications]: 'v3_notifications',
  [PANELS.confirmationPage]: 'v3_confirmation_page'
}

export const PANEL_KEYS_WITH_COMPONENTS = [
  PANELS.duration,
  PANELS.location,
  PANELS.availability,
  PANELS.groupEvent,
  PANELS.hosts,
  PANELS.assign,
  PANELS.description,
  PANELS.limitsAndBuffers,
  PANELS.freeBusyRules,
  PANELS.bookingPageOptions,
  PANELS.inviteeForm,
  PANELS.payment,
  PANELS.notifications,
  PANELS.confirmationPage
]
